import { EDSGlobalStyles, ScreenContext } from "@beckersdp/becker-ds";
import React, { FC } from "react";
import { hot } from "react-hot-loader/root";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { useScreen } from "./hooks/use-screen";
import { APPRouter } from "./router";
import { store } from "./store";
import { GlobalStyles, theme } from "./theme";

const loadMockServer = async () => {
  const { worker } = await import("./utils/test/api_mocks/browser");
  worker.start();
};

if (process.env.NODE_ENV === "development" && process.env.mocks) {
  loadMockServer();
}

const App: FC = () => (
  <ThemeProvider theme={theme}>
    <ScreenContext.Provider value={useScreen()}>
      <Provider store={store}>
        <APPRouter />
        <EDSGlobalStyles />
        <GlobalStyles />
      </Provider>
    </ScreenContext.Provider>
  </ThemeProvider>
);

export default hot(App);
